import { EntityType } from 'src/app/modules/admin/models/entity-type';
import { TargetEntityType } from 'src/app/modules/admin/models/target-entity-type';

export const mapEntityTypeFromTarget = (
  targetEntityType: TargetEntityType
): EntityType => ({
  entityTypeId: targetEntityType.entityTypeId,
  name: targetEntityType.name,
  isDefault: targetEntityType.isDefault,
  isActive: true,
  description: '',
});
